import { useZoomPanHelper } from 'react-flow-renderer';
import { useCallback } from 'react';
import { getNodeSize } from './use-layout';

export const useZoom = () => {
  const zoom = useZoomPanHelper();

  const onLoad = useCallback(
    instance => {
      const [root] = instance.getElements();

      const {
        position: { x },
      } = root || { width: 0, position: { x: 0 } };

      const [width] = getNodeSize(root.type);

      zoom.setCenter(x + Math.floor(width / 2), 0);
      zoom.zoomTo(1);
    },
    [zoom],
  );

  return {
    onLoad,
  };
};
